// app/javascript/controllers/service_history_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["template", "container", "filesContainer", "fileTemplate"]

  connect() {
    this.index = 0
    this.services = this.parseServices()
    console.log(this.services)
    this.renderExistingServices()
  }

  parseServices() {
    try {
      return JSON.parse(this.data.get("servicesValue"))
    } catch (e) {
      console.error("Error parsing services data:", e)
      return []
    }
  }

  addService(event) {
    event.preventDefault()
    this.addServiceEntry()
  }

  removeService(event) {
    event.preventDefault();
    const serviceElement = event.target.closest(".flex");
    const serviceId = serviceElement.dataset.id;
    const isNew = serviceElement.dataset.new === "true"; // Check if the entry is new
  
    if (confirm("Are you sure you want to delete this service entry?")) {
      if (isNew) {
        // Remove the element directly if it's new
        serviceElement.remove();
      } else {
        // Send a DELETE request if it's an existing record
        fetch(`/accounts/${this.data.get('accountId')}/vehicles/${this.data.get('vehicleId')}/delete_service_entry?service_entry_id=${serviceId}`, {
          method: 'DELETE',
          headers: {
            'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
            'Content-Type': 'application/json'
          }
        }).then(response => {
          if (response.ok) {
            serviceElement.remove();
          } else {
            alert("Failed to delete the service entry.");
          }
        });
      }
    }
  }

  renderExistingServices() {
    if (this.services && this.services.length > 0) {
      this.services.forEach((service, index) => {
        if (Object.keys(service).length > 0) {
          this.addServiceEntry(service, index)
        }
      })
    }
  }

  addServiceEntry(service = {}, index = this.index) {
    let content = this.templateTarget.innerHTML;
    for (const [key, value] of Object.entries(service)) {
      content = content.replace(new RegExp(`\\[INDEX\\]\\[${key}\\]`, 'g'), `[${index}][${key}]`);
      if (value) {
        if (key === 'service_notes') {
          // Special handling for service notes (textarea)
          content = content.replace(
            new RegExp(`<textarea([^>]*)name="vehicle\\[service_entries_attributes\\]\\[${index}\\]\\[${key}\\]"([^>]*)>(.*?)<\\/textarea>`, 'g'),
            `<textarea$1name="vehicle[service_entries_attributes][${index}][${key}]"$2>${value}</textarea>`
          );
        } else {
          // Original handling for other fields
          content = content.replace(new RegExp(`name="vehicle\\[service_entries_attributes\\]\\[${index}\\]\\[${key}\\]"`), `name="vehicle[service_entries_attributes][${index}][${key}]" value="${value}"`);
        }
      }
    }
    content = content.replace(/INDEX/g, index);
  
    const serviceEntryId = (service.id || `new_${index}`).toString();
    content = content.replace(/SERVICE_ENTRY_ID_PLACEHOLDER/g, serviceEntryId);
  
    // Insert at the beginning instead of the end
    this.containerTarget.insertAdjacentHTML("afterbegin", content);
  
    const serviceElement = this.containerTarget.firstElementChild; // Get the newly added element
    if (service.id) {
      serviceElement.querySelector(`input[name="vehicle[service_entries_attributes][${index}][id]"]`).value = service.id;
      serviceElement.dataset.id = service.id;
      serviceElement.dataset.new = "false"; // Mark as existing
    } else {
      serviceElement.dataset.id = index;
      serviceElement.dataset.new = "true"; // Mark as new
    }
    serviceElement.dataset.index = index; // Store the index in the data attribute
    this.index++;
  }
  
 
}
